import styled from 'styled-components';

/* TODO: Проверить зачем это  */

export const ContextMenuContainer = styled.div`
  width: 100%;
  height: 100%;
`;
